export default "__VITE_ASSET__417257c6__"